// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyBWNQAiS5rP_53rfHp2u7LJZbZwM9E6UhQ",
	authDomain: "self-love-app-d7106.firebaseapp.com",
	projectId: "self-love-app-d7106",
	storageBucket: "self-love-app-d7106.appspot.com",
	messagingSenderId: "842060159013",
	appId: "1:842060159013:web:29dcdce228ee9e74bec7cc",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
